/**
@ngdoc directive
@name directiveExample

@description
This is ngDoc description example for the exemplary directive. Please add the description.

@param {string} test1 - one-way data bound - please desribe
@param {variable} test2 - two-way data bound - please describe
*/

(function() {
    'use strict';

    var directiveExample = function() {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                test1: '@', // binded as text
                test2: '=' // double binded
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                this.$onInit = function(){
                    if(!angular.isDefined(_this.test1)){
                        throw "directiveExample: test1 has to defined!";
                    }
                    console.log(_this.test1);
                }
            }],
            replace: false,
            transclude: false,
            link: function(scope, element, attrs) {
                // console.log(attrs);
                element.bind('click', function(){
                    // console.log('clicked');
                    // console.log(attrs.container);
                });
            }

        };
    }
    angular.module('app').directive('directiveExample', directiveExample);

}());